export default __webpack_public_path__ + "static/media/crystalia.bf26eee1.webp";